var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgViewIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.929,
    height: 12.913,
    viewBox: "0 0 22.929 12.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "viewIcon",
    transform: "translate(0.535 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11099",
    "data-name": "Path 11099",
    d: "M27.753,23.049c-.2-.232-4.9-5.674-10.824-5.674S6.3,22.818,6.1,23.049a.437.437,0,0,0,0,.568c.2.232,4.9,5.67,10.824,5.67s10.627-5.438,10.824-5.67A.437.437,0,0,0,27.753,23.049Z",
    transform: "translate(-5.999 -17.375)",
    fill: "none",
    stroke: "var(--secondaryColor)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11100",
    "data-name": "Path 11100",
    d: "M25.777,29.829a4.057,4.057,0,1,1,4.052-4.053A4.059,4.059,0,0,1,25.777,29.829Z",
    transform: "translate(-14.847 -19.817)",
    fill: "var(--secondaryColor)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIconActive);
export default __webpack_public_path__ + "static/media/viewIconActive.389cae99682375d21a6e26e7627e1588.svg";
export { ForwardRef as ReactComponent };